import * as React from 'react';
import { HeaderContext } from '@core-front/header-provider';
import { debounce } from '@core-front/helper';
const MiniHeaderCore = (props) => {
    const { Languages, Logo, Container, SkipLinks } = props.components;
    const { languages, logo, className, externalLogo } = props;
    const headerContext = React.useContext(HeaderContext);
    const element = React.createRef();
    const debouncedResizeHandler = debounce(setHeaderHeight, 100);
    React.useEffect(() => {
        setHeaderHeight();
        window.addEventListener('resize', debouncedResizeHandler);
        return () => {
            window.removeEventListener('resize', debouncedResizeHandler);
            debouncedResizeHandler.clear();
        };
    });
    function BEM() {
        const classArray = ['mini-header'];
        if (!(logo || externalLogo) && languages) {
            classArray.push('mini-header--no-logo');
        }
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    }
    function setHeaderHeight() {
        if (element.current) {
            headerContext.setHeaderHeight(element.current.clientHeight);
        }
    }
    return (React.createElement("header", { className: BEM(), ref: element },
        props.skipLinks && props.skipLinks.length > 0 && React.createElement(SkipLinks, { links: props.skipLinks }),
        (logo || externalLogo || languages) && (React.createElement(Container, { className: "mini-header__inner" },
            (logo || externalLogo) && (React.createElement(Logo, Object.assign({ size: "small", text: "Core" // only needed for TS when using externalLogo - but that external logo should have its own text anyway.
             }, logo))),
            languages && React.createElement(Languages, { languages: languages })))));
};
export default MiniHeaderCore;
